<template>
    <div>
        <v-form>
            <v-row>
                <v-col cols="6">
                    <v-text-field label="Company" v-model="query.company" :disabled="searching" tabindex="1" autofocus />
                    <v-btn color="primary" @click="search" dark depressed :disabled="searching" type="submit" tabindex="3">
                        <v-icon left dark>mdi-account-search</v-icon> Search
                    </v-btn>
                    <span v-if="error" class="err">An error occurred. Please try again.</span>
                </v-col>
                <v-col cols="3">
                    <v-text-field label="Job title" v-model="query.job" :disabled="searching" tabindex="2" />
                </v-col>
                <v-col cols="1">
                    <v-select label="Offset" v-model="query.offset" :items="offsets"></v-select>
                </v-col>
                <v-col cols="2">
                    <v-img :src="logo" />
                </v-col>
            </v-row>
        </v-form>

        <v-data-table :headers="header"
                      :items="results"
                      :loading="searching"
                      class="elevation-1 mt-5"
                      :hide-default-footer="true"
                      mobile-breakpoint="0"
        >
            <template v-slot:item.link="{ value }">
                <a :href="value" target="_blank">{{ value }}</a>
            </template>
        </v-data-table>
    </div>
</template>

<style scoped lang="scss">
    .err {
        color: red;
        margin-left: 5px;
        display: inline-block;
    }
    .results {
        margin-top: 10px;

        > div {
            padding-bottom: 5px;
            margin-bottom: 15px;
            border-bottom: 1px solid var(--v-primary);
        }
    }
</style>

<script>
import ProductMixin from "@/mixins/Product";
import Logo from "@/assets/linked-in.png";

export default {
    data: () => ({
        query: {
            company: null,
            job: null,
            offset: 0,
        },
        searching: false,
        offsets: [0, 10, 20, 30, 40],
        results: [],
        logo: Logo,
        error: false,
        empty: false,
        header: [
            { text: "Name", value: "name", class: 'primary white--text' },
            { text: "Job title", value: "job", class: 'primary white--text' },
            { text: "Company", value: "company", class: 'primary white--text' },
            { text: "Link", value: "link", class: 'primary white--text' }
        ],
    }),
    mixins: [ProductMixin],
    methods: {
        async search() {
            this.searching = true;
            this.results = [];
            this.error = false;

            try
            {
                this.results = await this.action("search", this.query);
                this.empty = (this.results.length === 0);
            }
            catch
            {
                this.error = true;
            }         

            this.searching = false;
        }
    }
}
</script>